import React, { useState } from 'react'
import WhatsAppModal from './WhatsAppModal'
import WhatsAppIcon from './WhatsAppIcon'

const buttonClass = 'gap-2 px-3 py-[0.65rem] rounded-full bg-woperty-teal-light hover:bg-woperty-teal border-2 border-woperty-teal shadow-lg transition-all duration-200 group focus:outline-none focus-visible:outline-none focus:shadow-none active:no-underline'

function ChatButtonContent() {
  return (
    <>
      <WhatsAppIcon className="w-6 h-6 text-woperty-teal group-hover:text-white" />
      <span className="text-woperty-teal group-hover:text-white font-medium text-[0.85rem] select-none">
        Chat
      </span>
    </>
  )
}

export default function WhatsAppChat({ waArrendatario, waPropietario }) {
  const [open, setOpen] = useState(false)
  const singleLink = waArrendatario && !waPropietario ? waArrendatario
    : waPropietario && !waArrendatario ? waPropietario
    : null

  if (singleLink) {
    return (
      <div className="fixed bottom-6 mb-12 md:mb-0 right-6 z-[60]">
        <a
          href={singleLink}
          target="_blank"
          rel="noopener noreferrer"
          className={`flex items-center justify-center cursor-pointer no-underline hover:no-underline ${buttonClass}`}
        >
          <ChatButtonContent />
        </a>
      </div>
    )
  }

  return (
    <div className="fixed bottom-6 mb-12 md:mb-0 right-6 z-[60] flex flex-col items-end gap-3">
      {open && (
        <WhatsAppModal
          onClose={() => setOpen(false)}
          waArrendatario={waArrendatario}
          waPropietario={waPropietario}
        />
      )}
      <button
        onClick={() => setOpen(v => !v)}
        aria-label={open ? 'Cerrar chat' : 'Abrir chat de WhatsApp'}
        className={`flex items-center justify-center cursor-pointer ${
          open
            ? 'w-13 h-13 rounded-full bg-woperty-teal hover:bg-woperty-teal-hover border-2 border-woperty-teal shadow-lg transition-all duration-200 focus:outline-none focus-visible:outline-none focus:shadow-none'
            : buttonClass
        }`}
      >
        {open ? (
          <svg
            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="22" height="22"
            fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" aria-hidden="true"
            style={{ animation: 'spin-in 0.3s ease-out forwards' }}
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        ) : (
          <ChatButtonContent />
        )}
      </button>
    </div>
  )
}
